export default __webpack_public_path__ + "static/media/icon-box-delete.83960846.svg";